import { Dialog } from '@sunwebgroup/uds-ui/dialog'
import { Divider } from '@sunwebgroup/uds-ui/divider'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import cn from 'classnames'
import React from 'react'
import { useIntl } from '@/intl'
import styles from './Queue.module.css'

interface Props {
  waitingTime: number | null
  onCountdownEnd?: () => void
}

export default function Queue(props: Props) {
  const intl = useIntl()
  const { waitingTime, onCountdownEnd } = props
  const [countdown, setCountdown] = React.useState(waitingTime)

  React.useEffect(() => {
    setCountdown(waitingTime)
  }, [waitingTime])

  React.useEffect(() => {
    if (countdown === null)
      return
    if (countdown <= 0) {
      onCountdownEnd?.()
      return
    }
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev === null)
          return null
        if (prev <= 1) {
          clearInterval(timer)
          return 0
        }
        return prev - 1
      })
    }, 1000)
    return () => clearInterval(timer)
  }, [countdown, onCountdownEnd])

  return (
    <Dialog
      className={cn(styles.wrapper)}
      type="custom"
      icon="Spinner"
      text={intl.formatMessage({ id: 'groups_checkout_queue_waiting_title' })}
      supportingText={intl.formatMessage(
        { id: 'groups_checkout_queue_waiting_message' },
        { minutes: FormatSecondsToMinutes(countdown) },
      )}
      actionsSlot={(
        <div className={cn(styles.flexContent)}>
          <Divider />
          <Typography variant="body-s-regular-snug">
            {intl.formatMessage({ id: 'groups_checkout_queue_waiting_warning' })}
          </Typography>
          <Divider />
        </div>
      )}
    />
  )
}

function FormatSecondsToMinutes(seconds: number | null): string {
  if (seconds === null)
    return '0:00'
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = (seconds % 60).toString().padStart(2, '0')
  return `${minutes}:${remainingSeconds}`
}
